/**
 * LoveLab PDP click/tap-to-zoom — mirrors React ImageZoom behavior.
 * Click/tap toggles scale; when zoomed, pointer/touch pans via transform-origin.
 */
(function () {
  var ZOOM_SCALE = 2.5;
  var TAP_THRESHOLD = 10;
  var TAP_MAX_TIME = 300;

  var HINT_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg>';

  var CLOSE_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>';

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function i18n(key, fallback) {
    var dict = window.llI18n || {};
    return dict[key] || fallback;
  }

  function ensureUi(container) {
    var hintDesktop = container.querySelector('.ll-image-zoom__hint--desktop');
    var hintMobile = container.querySelector('.ll-image-zoom__hint--mobile');
    var closeBtn = container.querySelector('.ll-image-zoom__close');
    var hintOut = container.querySelector('.ll-image-zoom__hint-out');

    // Upgrade legacy static "Click to zoom" pill if present
    if (!hintDesktop) {
      var children = container.children;
      for (var i = 0; i < children.length; i++) {
        var el = children[i];
        if (
          el.tagName !== 'IMG' &&
          el.tagName !== 'BUTTON' &&
          !el.classList.contains('ll-image-zoom__hint') &&
          /click to zoom/i.test(el.textContent || '')
        ) {
          el.classList.add('ll-image-zoom__hint', 'll-image-zoom__hint--desktop');
          hintDesktop = el;
          break;
        }
      }
    }

    if (!hintDesktop) {
      hintDesktop = document.createElement('div');
      hintDesktop.className = 'll-image-zoom__hint ll-image-zoom__hint--desktop';
      hintDesktop.setAttribute('aria-hidden', 'true');
      hintDesktop.innerHTML = HINT_SVG + '<span>' + i18n('clickToZoom', 'Click to zoom') + '</span>';
      container.appendChild(hintDesktop);
    }

    if (!hintMobile) {
      hintMobile = document.createElement('div');
      hintMobile.className = 'll-image-zoom__hint ll-image-zoom__hint--mobile';
      hintMobile.setAttribute('aria-hidden', 'true');
      hintMobile.innerHTML = HINT_SVG + '<span>' + i18n('tapToZoom', 'Tap to zoom') + '</span>';
      container.appendChild(hintMobile);
    }

    if (!closeBtn) {
      closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'll-image-zoom__close';
      closeBtn.setAttribute('aria-label', i18n('closeZoom', 'Close zoom'));
      closeBtn.innerHTML = CLOSE_SVG;
      container.appendChild(closeBtn);
    }

    if (!hintOut) {
      hintOut = document.createElement('div');
      hintOut.className = 'll-image-zoom__hint-out';
      hintOut.setAttribute('aria-hidden', 'true');
      hintOut.textContent = i18n('tapToZoomOut', 'Tap to zoom out');
      container.appendChild(hintOut);
    }

    return { hintDesktop: hintDesktop, hintMobile: hintMobile, closeBtn: closeBtn, hintOut: hintOut };
  }

  function initZoom(container) {
    // React disables ImageZoom inside the mobile swipe carousel so horizontal
    // swipes are not captured. Skip zoom below the lg breakpoint for gallery tiles.
    if (
      container.closest('.ll-cuty-media-list') &&
      window.matchMedia('(max-width: 1023px)').matches
    ) {
      return;
    }
    if (container.dataset.llZoomInit === '1') return;

    var img = container.querySelector('img');
    if (!img) return;
    // Skip tiles that only show video
    if (container.querySelector('video') && !img) return;

    container.dataset.llZoomInit = '1';
    container.classList.add('ll-image-zoom');
    img.classList.add('ll-image-zoom__img');

    var ui = ensureUi(container);
    var isZooming = false;
    var position = { x: 50, y: 50 };
    var isTouching = false;
    var touchStart = null;
    var touchMoved = false;
    var rafId = null;
    var suppressClickUntil = 0;
    var baseScale = parseFloat(img.getAttribute('data-ll-base-scale') || '1');
    if (!isFinite(baseScale) || baseScale <= 0) baseScale = 1;

    function applyTransform() {
      var scale = isZooming ? ZOOM_SCALE : baseScale;
      img.style.transform = 'scale(' + scale + ')';
      img.style.transformOrigin = position.x + '% ' + position.y + '%';
      img.style.transition = isTouching ? 'none' : 'transform 0.3s ease-out';
      img.style.willChange = 'transform';
    }

    function setZooming(next) {
      isZooming = next;
      container.classList.toggle('is-zoomed', isZooming);
      container.style.touchAction = isZooming ? 'none' : 'pan-y';
      applyTransform();
    }

    function updatePosition(clientX, clientY) {
      var rect = container.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      position.x = clamp(((clientX - rect.left) / rect.width) * 100, 0, 100);
      position.y = clamp(((clientY - rect.top) / rect.height) * 100, 0, 100);
      applyTransform();
    }

    function updatePositionThrottled(clientX, clientY) {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(function () {
        updatePosition(clientX, clientY);
        rafId = null;
      });
    }

    function toggleZoom(clientX, clientY) {
      updatePosition(clientX, clientY);
      setZooming(!isZooming);
    }

    container.addEventListener('click', function (e) {
      if (e.target.closest('.ll-image-zoom__close')) return;
      // Avoid double-toggle from the synthetic click after a touch tap
      if (Date.now() < suppressClickUntil) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      toggleZoom(e.clientX, e.clientY);
    });

    container.addEventListener('mousemove', function (e) {
      if (!isZooming) return;
      updatePosition(e.clientX, e.clientY);
    });

    container.addEventListener(
      'touchstart',
      function (e) {
        if (e.touches.length !== 1) return;
        var t = e.touches[0];
        touchStart = { x: t.clientX, y: t.clientY, time: Date.now() };
        touchMoved = false;
        isTouching = true;
      },
      { passive: true }
    );

    container.addEventListener(
      'touchmove',
      function (e) {
        if (!touchStart || e.touches.length !== 1) return;
        var t = e.touches[0];
        var dx = Math.abs(t.clientX - touchStart.x);
        var dy = Math.abs(t.clientY - touchStart.y);
        var distance = Math.sqrt(dx * dx + dy * dy);
        if (distance > TAP_THRESHOLD) {
          touchMoved = true;
          if (isZooming) {
            e.preventDefault();
            updatePositionThrottled(t.clientX, t.clientY);
          }
        }
      },
      { passive: false }
    );

    container.addEventListener('touchend', function (e) {
      if (!touchStart || e.changedTouches.length !== 1) return;
      var t = e.changedTouches[0];
      var dx = Math.abs(t.clientX - touchStart.x);
      var dy = Math.abs(t.clientY - touchStart.y);
      var distance = Math.sqrt(dx * dx + dy * dy);
      var elapsed = Date.now() - touchStart.time;
      var wasTap = !touchMoved && distance < TAP_THRESHOLD && elapsed < TAP_MAX_TIME;
      if (wasTap) {
        suppressClickUntil = Date.now() + 500;
        toggleZoom(t.clientX, t.clientY);
      }
      touchStart = null;
      touchMoved = false;
      isTouching = false;
      applyTransform();
    });

    ui.closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      setZooming(false);
    });

    // Reset zoom when variant scripts swap the image src
    var lastSrc = img.getAttribute('src');
    var srcObserver = new MutationObserver(function () {
      var next = img.getAttribute('src');
      if (next !== lastSrc) {
        lastSrc = next;
        setZooming(false);
        position = { x: 50, y: 50 };
        applyTransform();
      }
    });
    srcObserver.observe(img, { attributes: true, attributeFilter: ['src'] });

    applyTransform();
  }

  function initAll() {
    // React ProductGallery: only zoomable packshots use ImageZoom.
    // Lifestyle tiles stay object-cover. Never attach zoom to every tile —
    // that added .ll-image-zoom after load and shrank lifestyle photos
    // (contain + padding).
    document.querySelectorAll('.ll-cuty-media-item.ll-image-zoom').forEach(function (item) {
      if (item.querySelector('img')) initZoom(item);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
